const amount = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? Math.max(0, parsed) : 0;
};

const normalizeMethod = (entry) =>
  String(entry?.methodId ?? entry?.method ?? entry?.code ?? entry?.name ?? "")
    .trim()
    .toLowerCase();

export const mergeJournalPaymentBreakdown = (entries = []) => {
  const merged = new Map();
  for (const entry of Array.isArray(entries) ? entries : []) {
    const key = normalizeMethod(entry) || "payment";
    const value = amount(entry?.amount);
    if (value <= 0) continue;
    const previous = merged.get(key);
    if (previous) {
      previous.amount += value;
    } else {
      merged.set(key, { ...entry, amount: value });
    }
  }
  return Array.from(merged.values());
};

export const buildJournalPaymentBreakdown = ({
  entries = [],
  paymentMethod,
  collectedAmount = 0,
  reserveRedeemedAmount = 0,
} = {}) => {
  const collected = amount(collectedAmount);
  const reserve = amount(reserveRedeemedAmount);
  const externalEntries = (Array.isArray(entries) ? entries : [])
    .filter((entry) => normalizeMethod(entry) !== "reserve")
    .map((entry) => ({ ...entry, amount: amount(entry?.amount) }))
    .filter((entry) => entry.amount > 0);

  if (!externalEntries.length && collected > 0) {
    externalEntries.push({ methodId: paymentMethod || "cash", amount: collected });
  }
  if (reserve > 0) {
    externalEntries.unshift({ methodId: "reserve", amount: reserve, isReserve: true });
  }
  return mergeJournalPaymentBreakdown(externalEntries);
};

export const parseReserveProof = (value) => {
  if (!value) return null;
  if (typeof value === "object") return value;
  try {
    const parsed = JSON.parse(value);
    return parsed && typeof parsed === "object" ? parsed : null;
  } catch (_) {
    return null;
  }
};
